const config = {
  PORTS_NUMBER: 12,
  PROJECT_NAME: 'QSIW',
  constant: {
    'PortSpeed': [
      {label: 'port.autoNegMode', value: 'autoNegMode'},
      {label: 'port.force1GModeFdx', value: 'oneGB_fdx'},
      {label: 'port.force100ModeFdx', value: 'hundredMBPS_fdx'},
      {label: 'port.force100ModeHdx', value: 'hundredMBPS_hdx'},
      {label: 'port.force10ModeFdx', value: 'tenMBPS_fdx'},
      {label: 'port.force10ModeHdx', value: 'tenMBPS_hdx'}
    ],
    'TwoG5Speed': [
      {label: 'port.autoNegMode', value: 'autoNegMode'},
      {label: 'port.force2p5GModeFdx', value: 'twothousandfivehundredMBPS_fdx'},
      {label: 'port.force1GModeFdx', value: 'oneGB_fdx'},
      {label: 'port.force100ModeFdx', value: 'hundredMBPS_fdx'},
      {label: 'port.force100ModeHdx', value: 'hundredMBPS_hdx'}
    ],
    'TenGspeed': [
      {label: 'port.autoNegMode', value: 'autoNegMode'},
      {label: 'port.force10GModeFdx', value: 'tenGB_fdx'},
      {label: 'port.force5GModeFdx', value: 'fivethousandMBPS_fdx'}, // 5g
      {label: 'port.force2p5GModeFdx', value: 'twothousandfivehundredMBPS_fdx'},
      {label: 'port.force1GModeFdx', value: 'oneGB_fdx'}
      // {label: 'port.force100ModeFdx', value: 'hundredMBPS_fdx'},
      // {label: 'port.force100ModeHdx', value: 'hundredMBPS_hdx'},
      // {label: 'port.force10ModeFdx', value: 'tenMBPS_fdx'},
      // {label: 'port.force10ModeHdx', value: 'tenMBPS_hdx'}
    ],
    'FecMode': [
      {label: 'systemInfo.off', value: 'none'},
      // {label: 'port.autoFec', value: 'auto'},
      // {label: 'port.baseRFec', value: 'FC_FEC'},
      {label: 'port.rsFec', value: 'RS_FEC'}
    ],
    'AggrMode': {
      'LACP_ACTIVE': 1,
      'LACP_STATIC': 2,
      'LACP_DISABLE': 3
    },
    'SystemLog': {
      'error': 3,
      'warning': 4,
      'notice': 5,
      'informational': 6,
      'all': 8
    },
    'SystemFlag': {
      'Clear': 0,
      'GetFirst': 1,
      'GetPrevious': 2,
      'GetNext': 3,
      'GetLast': 4
    },
    'TransMode': {
      'disabled': 'Disable',
      'rxOnly': 'Tx Only',
      'txOnly': 'Rx Only',
      'txAndRx': 'Both Tx & Rx'
    },
    'DeviceType': {
      'PC': 'PC',
      'NOTEBOOK': 'Notebook',
      'NAS': 'NAS',
      'ACCESSPOINT': 'Access Point',
      'IPCAM': 'IP Camera',
      'ROUTER': 'Router',
      'SWITCH': 'Switch',
      'OTHERS': 'Others'
    }
  },
  system: {
    cookieSID: 'QSW_SID',
    cookieLoginTime: 'QSW_Login',
    cookieShowFwWin: 'QSW_FW'
  },
  productDiff: {
    'QSW-M408-4C': {
      isNewUi: false,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: true,
      isDst: true,
      sfpPort: [],
      minNumber: 8,
      lagKey: 0,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8],
      speed2Group: [9, 10, 11, 12],
      speed1: ['oneG', 1],
      speed2: ['tenG', 10]
    },
    'QSW-M408S': {
      isNewUi: false,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: true,
      isDst: true,
      sfpPort: [9, 10, 11, 12],
      minNumber: 8,
      lagKey: 0,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8],
      speed2Group: [9, 10, 11, 12],
      speed1: ['oneG', 1],
      speed2: ['tenG', 10]
    },
    'QSW-M408-2C': {
      isNewUi: false,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: true,
      isDst: true,
      sfpPort: [9, 10],
      minNumber: 8,
      lagKey: 0,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8],
      speed2Group: [9, 10, 11, 12],
      speed1: ['oneG', 1],
      speed2: ['tenG', 10]
    },
    'QSW-IM1200-8C': {
      isNewUi: false,
      isEnterprice: true,
      isMultiSpeed: false,
      isFec: false,
      isLoopBack: true,
      isDst: true,
      sfpPort: [9, 10, 11, 12],
      minNumber: 0,
      lagKey: 0,
      speed1Group: [],
      speed2Group: [],
      speed1: ['tenG', 10]
    },
    'QSW-M1204-4C': {
      isNewUi: false,
      isEnterprice: true,
      isMultiSpeed: false,
      isFec: false,
      isLoopBack: true,
      isDst: true,
      sfpPort: [1, 2, 3, 4, 5, 6, 7, 8],
      minNumber: 0,
      lagKey: 0,
      speed1Group: [],
      speed2Group: [],
      speed1: ['tenG', 10]
    },
    'QSW-M1208-8C': {
      isNewUi: false,
      isEnterprice: true,
      isMultiSpeed: false,
      isFec: false,
      isLoopBack: true,
      isDst: true,
      sfpPort: [1, 2, 3, 4],
      minNumber: 0,
      lagKey: 0,
      speed1Group: [],
      speed2Group: [],
      speed1: ['tenG', 10]
    },
    'QSW-M804-4C': {
      isNewUi: false,
      isEnterprice: true,
      isMultiSpeed: false,
      isFec: false,
      isLoopBack: true,
      isDst: true,
      sfpPort: [1, 2, 3, 4],
      minNumber: 0,
      lagKey: 5,
      speed1Group: [],
      speed2Group: [],
      speed1: ['tenG', 10]
    },
    'QSW-M2108-2C': {
      isNewUi: false,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: false,
      isDst: false,
      sfpPort: [],
      minNumber: 8,
      lagKey: 19,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8],
      speed2Group: [9, 10],
      speed1: ['2G5', 2.5],
      speed2: ['tenG', 10]
    },
    'QSW-M2108R-2C': {
      isNewUi: false,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: false,
      isDst: false,
      sfpPort: [],
      minNumber: 8,
      lagKey: 19,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8],
      speed2Group: [9, 10],
      speed1: ['2G5', 2.5],
      speed2: ['tenG', 10]
    },
    'QSW-M2108-2S': {
      isNewUi: false,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: false,
      isDst: false,
      sfpPort: [9, 10],
      minNumber: 8,
      lagKey: 19,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8],
      speed2Group: [9, 10],
      speed1: ['2G5', 2.5],
      speed2: ['tenG', 10]
    },
    'QSW-M5216-1T': {
      isNewUi: false,
      isEnterprice: true,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: false,
      isDst: false,
      sfpPort: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      minNumber: 16,
      lagKey: 1,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      speed2Group: [17],
      speed2: ['twentyG5', 25], // let 10GbE be in front of 25GbE at Dashboard > Device information list
      speed1: ['tenG', 10] // dashboard getPortTrafficName
    },
    'QSW-M2106-4C': {
      isNewUi: true,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: false,
      isDst: false,
      sfpPort: [],
      minNumber: 6,
      lagKey: 19,
      speed1Group: [1, 2, 3, 4, 5, 6],
      speed2Group: [7, 8, 9, 10],
      speed1: ['2G5', 2.5],
      speed2: ['tenG', 10]
    },
    'QSW-M2106-4S': {
      isNewUi: true,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: false,
      isDst: false,
      sfpPort: [7, 8, 9, 10],
      minNumber: 6,
      lagKey: 19,
      speed1Group: [1, 2, 3, 4, 5, 6],
      speed2Group: [7, 8, 9, 10],
      speed1: ['2G5', 2.5],
      speed2: ['tenG', 10]
    },
    'QSW-M2106R-2S2T': {
      isNewUi: true,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: false,
      isDst: false,
      sfpPort: [9, 10],
      minNumber: 6,
      lagKey: 19,
      speed1Group: [1, 2, 3, 4, 5, 6],
      speed2Group: [7, 8, 9, 10],
      speed1: ['2G5', 2.5],
      speed2: ['tenG', 10]
    },
    'QSW-M2106PR-2S2T': {
      isNewUi: true,
      isEnterprice: false,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: false,
      isDst: false,
      sfpPort: [9, 10],
      minNumber: 6,
      lagKey: 19,
      speed1Group: [1, 2, 3, 4, 5, 6],
      speed2Group: [7, 8, 9, 10],
      speed1: ['2G5', 2.5],
      speed2: ['tenG', 10]
    },
    'QSW-M5212R-6F': {
      isNewUi: false,
      isEnterprice: true,
      isMultiSpeed: true,
      isFec: false,
      isLoopBack: true,
      sfpPort: [13, 14, 15, 16, 17, 18],
      minNumber: 12,
      lagKey: 0,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      speed2Group: [13, 14, 15, 16, 17, 18],
      speed1: ['twentyG5', 25],
      speed2: ['tenG', 10]
    },
    'QSW-M3224-24T': {
      isNewUi: false,
      isEnterprice: true,
      isMultiSpeed: false,
      isFec: false,
      isLoopBack: true,
      isDst: false,
      sfpPort: [],
      minNumber: 0,
      lagKey: 0,
      speed1Group: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      speed2Group: [],
      speed1: ['tenG', 10]
    }
  },
  menu: {
    'DASHBOARD': {
      'mode': 'BOTH',
      'title': 'menu.dashboard',
      'path': 'dashboard'
    },
    'CONFIGURE': {
      'mode': 'BOTH',
      'open': true,
      'title': 'menu.configurations',
      'path': 'configurations',
      'submenu': {
        'PORT': {
          'mode': 'BOTH',
          'title': 'menu.port',
          'path': 'portstatus',
          'alias': 'portstatus',
          'submenu': {
            'portstatus': {
              'title': 'menu.portstatus',
              'path': 'portstatus'
            },
            'portstatistics': {
              'title': 'menu.portstatistics',
              'path': 'portstatistics'
            },
            'portconfigure': {
              'title': 'menu.portconfigure',
              'path': 'portconfigure'
            }
          }
        },
        'POE': {
          'mode': 'BOTH',
          'title': 'menu.poe',
          'path': 'poeconsumption',
          'alias': 'poeconsumption',
          'submenu': {
            'poeconsumption': {
              'title': 'menu.powerConsumption',
              'path': 'poeconsumption'
            },
            'poeconfiguration': {
              'title': 'menu.powerConfiguration',
              'path': 'poeconfiguration'
            },
            'poeschedule': {
              'title': 'menu.poeSchedule',
              'path': 'poeschedule'
            }
          }
        },
        'VLAN': {
          'mode': 'BOTH',
          'title': 'menu.vlan',
          'path': 'vlan',
          'submenu': {
            'vlan': {
              'title': 'menu.vlan',
              'path': 'vlan'
            }
          }
        },
        'AGGREGATION': {
          'mode': 'BOTH',
          'title': 'menu.aggregation',
          'path': 'lag',
          'submenu': {
            'lag': {
              'title': 'menu.aggregation',
              'path': 'lag'
            }
          }
        },
        'RSTP': {
          'mode': 'BOTH',
          'title': 'menu.rstp',
          'path': 'rstp',
          'submenu': {
            'rstp': {
              'title': 'menu.rstpconfig',
              'path': 'rstp'
            }
          }
        },
        'LOOPPROTECTION': {
          'mode': 'BOTH',
          'title': 'loopProtection.loopProtection',
          'path': 'loopprotection',
          'submenu': {
            'loopprotection': {
              'title': 'loopProtection.loopProtection',
              'path': 'loopprotection'
            }
          }
        },
        'lldp': {
          'mode': 'BOTH',
          'title': 'menu.lldp',
          'path': 'lldpconfig',
          'submenu': {
            'lldpconfig': {
              'title': 'menu.lldpconfig',
              'path': 'lldpconfig'
            },
            'lldpremote': {
              'title': 'menu.lldpremote',
              'path': 'lldpremote'
            },
            'mactable': {
              'title': 'menu.mactable',
              'path': 'mactable'
            }
          }
        },
        'IGMP': {
          'mode': 'BOTH',
          'title': 'menu.igmpsnooping',
          'path': 'igmpsnooping',
          'submenu': {
            'igmpsnooping': {
              'title': 'menu.igmpsnooping',
              'path': 'igmpsnooping'
            },
            'igmpstatistic': {
              'title': 'menu.igmpstatistic',
              'path': 'igmpstatistic'
            }
          }
        },
        'ACL': {
          'mode': 'BOTH',
          'title': 'menu.acl',
          'path': 'aclip',
          'submenu': {
            'aclip': {
              'title': 'menu.aclip',
              'path': 'aclip'
            },
            'aclmac': {
              'title': 'menu.aclmac',
              'path': 'aclmac'
            }
          }
        },
        'QOS': {
          'mode': 'BOTH',
          'title': 'menu.qos',
          'path': 'qos',
          'submenu': {
            'qos': {
              'title': 'menu.qos',
              'path': 'qos'
            }
          }
        }
        // 'Mirro': {
        //   'mode': 'BOTH',
        //   'title': 'menu.portmirroring',
        //   'path': 'portmirroring',
        //   'submenu': {
        //     'mirror': {
        //       'title': 'menu.portmirroring',
        //       'path': 'portmirroring'
        //     }
        //   }
        // }
      }
    },
    'SYSMANAGEMENT': {
      'mode': 'BOTH',
      'open': true,
      'title': 'menu.systemMgmt',
      'path': 'sysmanagement',
      'submenu': {
        'SYSTEMINFO': {
          'mode': 'BOTH',
          'title': 'menu.sysControl',
          'path': 'sysinformation',
          'submenu': {
            'sysinformation': {
              'title': 'menu.sysinformation',
              'path': 'sysinformation'
            },
            'sysdhcp': {
              'title': 'menu.sysdhcp',
              'path': 'sysdhcp'
            },
            'syspassword': {
              'title': 'menu.syspassword',
              'path': 'syspassword'
            },
            'systime': {
              'title': 'menu.systime',
              'path': 'systime'
            },
            'sysbackup': {
              'title': 'menu.sysbackup',
              'path': 'sysbackup'
            },
            'syshttps': {
              'title': 'menu.syshttps',
              'path': 'syshttps'
            }
            // 'syssnmp': {
            //   'title': 'menu.syssnmp',
            //   'path': 'syssnmp'
            // }
          }
        },
        'FIRMWAREUPDATE': {
          'mode': 'BOTH',
          'title': 'menu.firmwareupdate',
          'path': 'liveupdate',
          'submenu': {
            'liveupdate': {
              'title': 'menu.liveupdate',
              'path': 'liveupdate'
            },
            'firmwareupdate': {
              'title': 'menu.firmwareupdate',
              'path': 'firmwareupdate'
            }
          }
        }
      }
    }
  },
  languages: [
    ['en', 'English', 'ascii', 'ENG', 'eng'],
    ['CN', '简体中文', 'utf-8', 'SCH', 'chs'],
    ['TW', '繁體中文', 'utf-8', 'TCH', 'cht'],
    ['cz', 'Czech', 'utf-8', 'CZE', 'cze'],
    ['da', 'Dansk', 'utf-8', 'DAN', 'dan'],
    ['de', 'Deutsch', 'utf-8', 'GER', 'ger'],
    ['es', 'Español', 'utf-8', 'SPA', 'spa'],
    ['fr', 'Français', 'utf-8', 'FRE', 'fre'],
    ['it', 'Italiano', 'utf-8', 'ITA', 'ita'],
    ['ja', '日本語', 'utf-8', 'JPN', 'jpn'],
    ['ko', '한글', 'utf-8', 'KOR', 'kor'],
    ['no', 'Norsk', 'utf-8', 'NOR', 'nor'],
    ['pl', 'Polski', 'utf-8', 'POL', 'pol'],
    ['ru', 'Русский', 'utf-8', 'RUS', 'rus'],
    ['fi', 'Suomi', 'utf-8', 'FIN', 'fin'],
    ['sv', 'Svenska', 'utf-8', 'SWE', 'swe'],
    ['nl', 'Nederlands', 'utf-8', 'DUT', 'dut'],
    ['tr', 'Turk dili', 'utf-8', 'TUR', 'tur'],
    ['th', 'ไทย', 'utf-8', 'THA', 'tha'],
    ['pt', 'Português', 'utf-8', 'POR', 'por'],
    ['hu', 'Magyar', 'utf-8', 'HUN', 'hun'],
    ['el', 'Ελληνικά', 'utf-8', 'GRK', 'grk'],
    ['ro', 'Român', 'utf-8', 'ROM', 'rom']
  ],
  timezones: [
    {label: '(GMT-11:00) MidwayIsland,Samoa', offset: -660, value: 1},
    {label: '(GMT-10:00) Hawaii', offset: -600, value: 2},
    {label: '(GMT-09:30) Marquesa Is.', offset: -570, value: 3},
    {label: '(GMT-09:00) Alaska', offset: -540, value: 4},
    {label: '(GMT-08:00) Pacific Time(US & Canada); Tijuana', offset: -480, value: 5},
    {label: '(GMT-07:00) Arizona', offset: -420, value: 6},
    {label: '(GMT-07:00) Mountain Time(US & Canada)', offset: -420, value: 7},
    {label: '(GMT-06:00) Central Time(US & Canada)', offset: -360, value: 8},
    {label: '(GMT-06:00) Mexico City, Tegucigalpa', offset: -360, value: 9},
    {label: '(GMT-06:00) Saskatchewan', offset: -360, value: 10},
    {label: '(GMT-05:00) Bogota, Lima, Quito', offset: -300, value: 11},
    {label: '(GMT-05:00) Eastern Time(US & Canada)', offset: -300, value: 12},
    {label: '(GMT-05:00) Indiana (East)', offset: -300, value: 13},
    {label: '(GMT-04:00) Atlantic Time(Canada)', offset: -240, value: 14},
    {label: '(GMT-04:00) Caracas, La Paz', offset: -240, value: 15},
    {label: '(GMT-04:00) Santiago', offset: -240, value: 16},
    {label: '(GMT-03:00) Brasilia', offset: -180, value: 17},
    {label: '(GMT-03:00) Buenos Aires, Georgetown', offset: -180, value: 18},
    {label: '(GMT-03:00) Greenland Standard Time; Nuuk(Godthab)', offset: -180, value: 19},
    {label: '(GMT-02:00) Mid-Atlantic', offset: -120, value: 20},
    {label: '(GMT-01:00) Azores, Cape Verde Is.', offset: -60, value: 21},
    {label: '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London', offset: 0, value: 22},
    {label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', offset: 60, value: 23},
    {label: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', offset: 60, value: 24},
    {label: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris', offset: 60, value: 25},
    {label: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb', offset: 60, value: 26},
    {label: '(GMT+02:00) Athens, Vilnius', offset: 120, value: 27},
    {label: '(GMT+02:00) Bucharest', offset: 120, value: 28},
    {label: '(GMT+02:00) Cairo', offset: 120, value: 29},
    {label: '(GMT+02:00) Harare, Pretoria', offset: 120, value: 30},
    {label: '(GMT+02:00) Helsinki, Kyiv, Riga, Tallinn', offset: 120, value: 31},
    {label: '(GMT+02:00) Israel', offset: 120, value: 32},
    {label: '(GMT+02:00) Kaliningrad', offset: 120, value: 33},
    {label: '(GMT+03:00) Istanbul', offset: 180, value: 34},
    {label: '(GMT+03:00) Baghdad, Kuwait, Riyadh', offset: 180, value: 35},
    {label: '(GMT+03:00) Nairobi', offset: 180, value: 36},
    {label: '(GMT+03:00) Minsk', offset: 180, value: 37},
    {label: '(GMT+03:30) Moscow', offset: 180, value: 38},
    {label: '(GMT+03:30) Tehran', offset: 210, value: 39},
    {label: '(GMT+04:00) Abu Dhabi, Muscat', offset: 240, value: 40},
    {label: '(GMT+04:00) Baku, Tbilisi', offset: 240, value: 41},
    {label: '(GMT+04:00) Samara', offset: 240, value: 42},
    {label: '(GMT+04:30) Kabul', offset: 270, value: 43},
    {label: '(GMT+05:00) Islamabad, Karachi, Tashkent', offset: 300, value: 44},
    {label: '(GMT+05:00) Yekaterinburg', offset: 300, value: 45},
    {label: '(GMT+05:30) Bombay, Calcutta, Madras, New Delhi', offset: 330, value: 46},
    {label: '(GMT+05:30) Colombo', offset: 330, value: 47},
    {label: '(GMT+05:45) Nepal', offset: 345, value: 48},
    {label: '(GMT+06:00) Omsk', offset: 360, value: 49},
    {label: '(GMT+06:30) Myanmar', offset: 390, value: 50},
    {label: '(GMT+07:00) Bangkok, Hanoi, Jakarta', offset: 420, value: 51},
    {label: '(GMT+07:00) Krasnoyarsk', offset: 420, value: 52},
    {label: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi', offset: 480, value: 53},
    {label: '(GMT+08:00) Perth', offset: 480, value: 54},
    {label: '(GMT+08:00) Singapore', offset: 480, value: 55},
    {label: '(GMT+08:00) Taipei', offset: 480, value: 56},
    {label: '(GMT+08:00) Irkutsk', offset: 480, value: 57},
    {label: '(GMT+08:45) Eucla', offset: 525, value: 58},
    {label: '(GMT+09:00) Osaka, Sapporo, Tokyo', offset: 540, value: 59},
    {label: '(GMT+09:00) Seoul', offset: 540, value: 60},
    {label: '(GMT+09:00) Yakutsk', offset: 540, value: 61},
    {label: '(GMT+09:30) Adelaide', offset: 570, value: 62},
    {label: '(GMT+09:30) Darwin', offset: 570, value: 63},
    {label: '(GMT+10:00) Brisbane', offset: 600, value: 64},
    {label: '(GMT+10:00) Canberra, Melbourne, Sydney', offset: 600, value: 65},
    {label: '(GMT+10:00) Guam, Port Moresby', offset: 600, value: 66},
    {label: '(GMT+10:00) Hobart', offset: 600, value: 67},
    {label: '(GMT+10:00) Vladivostok', offset: 600, value: 68},
    {label: '(GMT+10:30) Lord Howe Is.', offset: 630, value: 69},
    {label: '(GMT+11:00) Srednekolymsk', offset: 660, value: 70},
    {label: '(GMT+11:00) Solomon Is.', offset: 660, value: 71},
    {label: '(GMT+11:00) New Caledonia', offset: 660, value: 72},
    {label: '(GMT+11:30) Norfolk Is.', offset: 705, value: 73},
    {label: '(GMT+12:00) Auckland, Wellington', offset: 720, value: 74},
    {label: '(GMT+12:00) Fiji , Kamchatka, Marshall Is.', offset: 720, value: 75},
    {label: '(GMT+12:00) Kamchatka.', offset: 720, value: 76},
    {label: '(GMT+12:00) Kwajalein.', offset: 720, value: 77},
    {label: '(GMT+12:45) Chatham Is.', offset: 765, value: 78},
    {label: '(GMT+13:00) Phoenix Is.', offset: 780, value: 79},
    {label: '(GMT+13:00) Tokelau', offset: 780, value: 80},
    {label: '(GMT+13:00) Samoa', offset: 780, value: 81},
    {label: '(GMT+14:00) Line Is', offset: 840, value: 82}
  ],
  dsttimezones: [],
  timeformats: [
    {label: 'yyyy/MM/DD', value: '0', format: 'YYYY/MM/DD'},
    {label: 'yyyy.MM.DD', value: '1', format: 'YYYY.MM.DD'},
    {label: 'yyyy-MM-DD', value: '2', format: 'YYYY-MM-DD'},
    {label: 'MM/DD/yyyy', value: '3', format: 'MM/DD/YYYY'},
    {label: 'MM.DD.yyyy', value: '4', format: 'MM.DD.YYYY'},
    {label: 'MM-DD-yyyy', value: '5', format: 'MM-DD-YYYY'},
    {label: 'DD/MM/yyyy', value: '6', format: 'DD/MM/YYYY'},
    {label: 'DD.MM.yyyy', value: '7', format: 'DD.MM.YYYY'},
    {label: 'DD-MM-yyyy', value: '8', format: 'DD-MM-YYYY'}
  ],
  hourformats: [
    {label: '24HR', value: '0', format: 'HH:mm:ss'},
    {label: '12HR', value: '1', format: 'hh:mm:ss a'}
  ],
  helper: {
    'portstatus': [
      { title: 'helper.portSettingContent1', level: 1 },
      { title: 'helper.portSettingContent2', level: 1 },
      { title: 'helper.portSettingContent3', level: 1 },
      { title: 'helper.vlanSettingContent5', level: 1 },
      { title: 'helper.portSettingContent5', cssStyle: 'remark' }
    ],
    'fecportstatus': [
      { title: 'helper.portSettingContent1', level: 1 },
      { title: 'helper.portSettingContent2', level: 1 },
      { title: 'helper.portSettingContent7', level: 1 },
      { title: 'helper.portSettingContent3', level: 1 },
      { title: 'helper.vlanSettingContent5', level: 1 },
      { title: 'helper.portSettingContent6', cssStyle: 'remark' }
    ],
    'vlan': [
      { title: 'helper.vlanSettingContent1', level: 1 },
      { title: 'helper.vlanSettingContent2', level: 1 },
      { title: 'helper.vlanSettingContent3', level: 1 },
      { title: 'helper.vlanSettingContent4', level: 1 },
      { title: 'helper.vlanSettingContent5', level: 1 },
      { title: 'helper.vlanSettingContent6', importImage: ['edit', 'trashcan'], level: 1 },
      { title: 'helper.vlanSettingContent7', cssStyle: 'remark' }
    ],
    'lag': [
      { title: 'helper.lagSettingContent1', level: 1 },
      { title: 'helper.lagSettingContent2', level: 1 },
      { title: 'helper.lagSettingContent3', level: 1 },
      { title: 'helper.lagSettingContent4', level: 0, cssStyle: 'dialog' },
      { title: 'helper.lagSettingContent5', level: 0, cssStyle: 'dialog' },
      { title: 'helper.lagSettingContent6', level: 1 },
      { title: 'helper.vlanSettingContent5', level: 1 },
      { title: 'helper.lagSettingContent8', importImage: ['edit', 'trashcan'], level: 1 },
      { title: 'helper.lagSettingContent9', cssStyle: 'remark' }
    ],
    'rstp': [
      { title: 'helper.rstpSettingContent1', level: 1 },
      { title: 'helper.rstpSettingContent2', level: 1 },
      { title: 'helper.rstpSettingContent3', level: 1 },
      { title: 'helper.rstpSettingContent4', level: 1 },
      { title: 'helper.vlanSettingContent5', level: 1 }
    ],
    'lldpconfig': [
      { title: 'helper.lldpSettingContent1', level: 1 },
      { title: 'helper.lldpSettingContent2', level: 1 }
      // { title: 'helper.lldpSettingContent3', level: 2, number: 1 },
      // { title: 'helper.lldpSettingContent4', level: 1 }
    ],
    'igmpsnooping': [
      { title: 'helper.igmpSettingContent1', level: 1 },
      { title: 'helper.igmpSettingContent2', level: 1 },
      { title: 'helper.igmpSettingContent3', level: 1 },
      { title: 'helper.igmpSettingContent4', level: 1 },
      { title: 'helper.vlanSettingContent5', level: 1 },
      { title: 'helper.igmpSettingContent6', cssStyle: 'remark' }
    ],
    'aclip': [
      { title: 'helper.aclSettingContent15', cssStyle: 'remark' },
      { title: 'helper.aclSettingContent1', level: 1 },
      { title: 'helper.aclSettingContent2', level: 1 },
      { title: 'helper.aclSettingContent3', level: 1 },
      { title: 'helper.aclSettingContent4', level: 2, number: 1 },
      { title: 'helper.aclSettingContent5', level: 2, number: 2 },
      { title: 'helper.aclSettingContent6', level: 2, number: 3 },
      { title: 'helper.aclSettingContent7', level: 2, number: 4 },
      { title: 'helper.aclSettingContent8', level: 2, number: 5 },
      { title: 'helper.vlanSettingContent5', level: 2, number: 6 },
      { title: 'helper.aclSettingContent10', level: 1 },
      { title: 'helper.aclSettingContent11', level: 2, number: 1 },
      { title: 'helper.aclSettingContent12', level: 2, number: 2 },
      { title: 'helper.aclSettingContent13', level: 2, number: 3 },
      { title: 'helper.aclSettingContent7', level: 2, number: 4 },
      { title: 'helper.aclSettingContent8', level: 2, number: 5 },
      { title: 'helper.vlanSettingContent5', level: 2, number: 6 },
      { title: 'helper.aclSettingContent14', level: 1, importImage: ['edit', 'trashcan'] }
    ],
    'qos': [
      { title: 'helper.qosSettingContent1', level: 1 },
      { title: 'helper.qosSettingContent2', level: 2, number: 1, importImage: ['edit'] },
      { title: 'helper.qosSettingContent3', level: 1 },
      { title: 'helper.qosSettingContent4', level: 2, number: 1, importImage: ['edit'] },
      { title: 'helper.qosSettingContent5', level: 1 },
      { title: 'helper.vlanSettingContent5', level: 1 },
      { title: 'helper.qosSettingContent7', cssStyle: 'remark' },
      { title: 'helper.qosSettingContent8', cssStyle: 'remark' }
    ],
    'poeconsumption': [
      { title: 'helper.poeSettingContent1', level: 0, cssStyle: 'dialog' },
      { title: 'helper.poeSettingContent2', level: 1 },
      { title: 'helper.poeSettingContent12', level: 1 },
      { title: 'helper.poeSettingContent3', level: 1 },
      { title: 'helper.poeSettingContent4', level: 1 },
      { title: 'helper.poeSettingContent5', level: 0, cssStyle: 'dialog' },
      { title: 'helper.poeSettingContent6', level: 1 },
      { title: 'helper.poeSettingContent7', level: 1 },
      { title: 'helper.poeSettingContent8', level: 1 },
      { title: 'helper.poeSettingContent9', level: 1 },
      { title: 'helper.poeSettingContent10', level: 1 },
      { title: 'helper.poeSettingContent11', level: 1 }
    ],
    'loopprotection': [
      { title: 'helper.loopProtectionContent1', level: 1 },
      { title: 'helper.loopProtectionContent2', level: 1 },
      { title: 'helper.loopProtectionContent3', cssStyle: 'remark' },
      { title: 'helper.loopProtectionContent4', level: 1 },
      { title: 'helper.loopProtectionContent5', cssStyle: 'remark' }
    ]
  },
  subnetList: [
    // { value: '255.255.255.255', label: '255.255.255.255 (/32)' },
    { value: '255.255.255.254', label: '255.255.255.254 (/31)' },
    { value: '255.255.255.252', label: '255.255.255.252 (/30)' },
    { value: '255.255.255.248', label: '255.255.255.248 (/29)' },
    { value: '255.255.255.240', label: '255.255.255.240 (/28)' },
    { value: '255.255.255.224', label: '255.255.255.224 (/27)' },
    { value: '255.255.255.192', label: '255.255.255.192 (/26)' },
    { value: '255.255.255.128', label: '255.255.255.128 (/25)' },
    { value: '255.255.255.0', label: '255.255.255.0 (/24)' },
    { value: '255.255.254.0', label: '255.255.254.0 (/23)' },
    { value: '255.255.252.0', label: '255.255.252.0 (/22)' },
    { value: '255.255.248.0', label: '255.255.248.0 (/21)' },
    { value: '255.255.240.0', label: '255.255.240.0 (/20)' },
    { value: '255.255.224.0', label: '255.255.224.0 (/19)' },
    { value: '255.255.192.0', label: '255.255.192.0 (/18)' },
    { value: '255.255.128.0', label: '255.255.128.0 (/17)' },
    { value: '255.255.0.0', label: '255.255.0.0 (/16)' },
    { value: '255.254.0.0', label: '255.254.0.0 (/15)' },
    { value: '255.252.0.0', label: '255.252.0.0 (/14)' },
    { value: '255.248.0.0', label: '255.248.0.0 (/13)' },
    { value: '255.240.0.0', label: '255.240.0.0 (/12)' },
    { value: '255.224.0.0', label: '255.224.0.0 (/11)' },
    { value: '255.192.0.0', label: '255.192.0.0 (/10)' },
    { value: '255.128.0.0', label: '255.128.0.0 (/9)' },
    { value: '255.0.0.0', label: '255.0.0.0 (/8)' },
    { value: '254.0.0.0', label: '254.0.0.0 (/7)' },
    { value: '252.0.0.0', label: '252.0.0.0 (/6)' },
    { value: '248.0.0.0', label: '248.0.0.0 (/5)' },
    { value: '240.0.0.0', label: '240.0.0.0 (/4)' },
    { value: '224.0.0.0', label: '224.0.0.0 (/3)' },
    { value: '192.0.0.0', label: '192.0.0.0 (/2)' },
    { value: '128.0.0.0', label: '128.0.0.0 (/1)' }
  ],
  dstDay: [
    { value: 'First', label: 'dstDay.First' },
    { value: 'Second', label: 'dstDay.Second' },
    { value: 'Third', label: 'dstDay.Third' },
    { value: 'Fourth', label: 'dstDay.Fourth' },
    { value: 'Last', label: 'dstDay.Last' }
  ],
  dstWeek: [
    { value: 'Sun', label: 'dstWeek.sun' },
    { value: 'Mon', label: 'dstWeek.mon' },
    { value: 'Tue', label: 'dstWeek.tue' },
    { value: 'Wed', label: 'dstWeek.wed' },
    { value: 'Thu', label: 'dstWeek.thu' },
    { value: 'Fri', label: 'dstWeek.fri' },
    { value: 'Sat', label: 'dstWeek.sat' }
  ],
  dstMonth: [
    { value: 'Jan', label: 'dstMonth.Jan' },
    { value: 'Feb', label: 'dstMonth.Feb' },
    { value: 'Mar', label: 'dstMonth.Mar' },
    { value: 'Apr', label: 'dstMonth.Apr' },
    { value: 'May', label: 'dstMonth.May' },
    { value: 'Jun', label: 'dstMonth.Jun' },
    { value: 'Jul', label: 'dstMonth.Jul' },
    { value: 'Aug', label: 'dstMonth.Aug' },
    { value: 'Sep', label: 'dstMonth.Sep' },
    { value: 'Oct', label: 'dstMonth.Oct' },
    { value: 'Nov', label: 'dstMonth.Nov' },
    { value: 'Dec', label: 'dstMonth.Dec' }
  ]
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js